module.exports = __webpack_public_path__ + "img/e_1_7_g.781ec849.png";